import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parse } from 'tldts';

export function domainValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value || typeof value !== 'string') {
      return { invalidDomain: true };
    }

    // Allow only http / https if protocol is present
    if (/^[a-zA-Z]+:\/\//.test(value) && !/^https?:\/\//i.test(value)) {
      return { invalidDomain: true };
    }

    // Use parse to get the components
    const result = parse(value);

    // Must have valid domain + publicSuffix
    if (!result.domain || !result.publicSuffix || !result.isIcann) {
      return { invalidDomain: true };
    }

     // Reject subdomains except "www"
    if (result.subdomain && result.subdomain !== 'www') {
      return { invalidDomain: true };
    }

    return null;
  };
}
